// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1433":"8c7ea5d3","1520":"9a0d361c","2374":"8b3ef933","5631":"9485aced","8898":"8b3ef933","9215":"c2ae701c"}[chunkId] + ".chunk.css";
};